<template>
  <div class="params-col">
    <div class="params-col__item params-row params-row_justify_center">
      <div class="params-row__item params-row__grow-item text-field">
        <div><span class="field-title">Text</span></div>
        <el-input
          :class="{ 'error-input': !textFit || text.length == 0 }"
          :value="text"
          class="text-param-field edit-input"
          type="text"
          @input="handleText"
        >
          Text
        </el-input>
      </div>
      <div class="params-row__item font-field">
        <div><span class="field-title">Font</span></div>
        <el-select
          v-model="fontFamily"
          class="edit-select"
          :style="{ 'font-family': fontFamily }"
        >
          <el-option
            v-for="font in textFonts"
            :key="font"
            :label="font"
            :value="font"
            :style="{ 'font-family': font }"
          />
        </el-select>
      </div>
      <div class="params-row__item size-field">
        <div><span class="field-title">Size</span></div>
        <el-select v-model="fontSize" class="edit-select">
          <el-option
            v-for="size in textSizes"
            :key="size"
            :label="size"
            :value="size"
          />
        </el-select>
      </div>
      <div class="params-row__item">
        <div><span class="field-title">Color</span></div>
        <el-color-picker v-model="fontColor" />
      </div>
    </div>

    <div class="params-col__item params-row">
      <div class="params-row__item params-row__grow-item">
        <div><span class="field-title">Timeline</span></div>
        <div style="height: 100%; padding: 0 50px;">
          <flex-time-slider
            :max-time="videoDuration"
            @change="timeline = $event"
          />
        </div>
      </div>
    </div>

    <div class="params-col__item params-row params-row_justify_center">
      <div class="params-row__item">
        <el-button v-if="!isTextAdded" type="success" @click="addText">
          Add text
        </el-button>
        <el-button v-else type="danger" @click="$emit('disableText')">
          Remove Text
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import FlexTimeSlider from "@/components/sliders/FlexTimeSlider.vue";
import { getFonts } from "@/api/fonts.js";

// @group Editing
// Overlay text parameters
export default {
  name: "EditTextPanel",
  components: {
    FlexTimeSlider
  },
  model: {
    prop: "textData",
    event: "updateTextData"
  },
  props: {
    // Text, font, size, color.
    textData: {
      type: Object,
      required: true
    },
    // Video duration in seconds
    videoDuration: {
      type: Number,
      required: true
    },
    // Is text fit to container
    textFit: {
      type: Boolean,
      default: true
    },
    // Is text field added to area
    isTextAdded: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      text: this.textData.text,
      fontFamily: this.textData.font,
      fontSize: this.textData.size,
      fontColor: this.textData.color,
      timeline: [0, 0],

      textFonts: [],
      textSizes: [
        8,
        9,
        10,
        11,
        12,
        14,
        18,
        20,
        24,
        28,
        32,
        40,
        48,
        54,
        60,
        66,
        72,
        80,
        90
      ]
    };
  },
  watch: {
    textData() {
      this.text = this.textData.text;
      this.fontFamily = this.textData.font;
      this.fontSize = this.textData.size;
      this.fontColor = this.textData.color;
    },
    // @vuese
    // Update text
    text() {
      this.updateData();
    },
    // @vuese
    // Update font
    fontFamily() {
      this.updateData();
    },
    // @vuese
    // Update font size
    fontSize() {
      this.updateData();
    },
    // @vuese
    // Update text color
    fontColor() {
      this.updateData();
    },
    // @vuese
    // Update text appear and dissapear time
    timeline(val) {
      // Text appear and dissapear time changed
      this.$emit("updateTimeline", val);
    },
    videoDuration(dur) {
      this.timeline = [0, dur];
    }
  },
  mounted() {
    this.initFonts()
  },
  methods: {
    initFonts() {
      getFonts().then(fonts => {
        this.textFonts = fonts;
        if (!fonts.includes(this.fontFamily)) {
          this.fontFamily = fonts.length > 0 ? fonts[0] : null;
        }
      });
    },
    // @vuese
    // Update textData parameters, when those updated
    updateData() {
      const newData = {
        text: this.text,
        font: this.fontFamily,
        size: this.fontSize,
        color: this.fontColor
      };
      // Text parameters changed
      this.$emit("updateTextData", newData);
    },
    // @vuese
    // Write text on video clip
    addText() {
      if (this.text.length == 0) {
        this.$alert("Text is empty", "Error");
        return;
      } else if (!this.textFit) {
        this.$alert("Text is too long", "Error");
        return;
      }
      // User start text adding
      this.$emit("enableText");
    },
    // @vuese
    // Process input, removing exceed spaces
    handleText(text) {
      this.text = text.replace(/\s+/g, " ");
    }
  }
};
</script>

<style scoped>
.font-field {
  width: 170px;
}
.size-field {
  width: 80px;
}

.field-title {
  font-weight: bold;
}
</style>

<style>
.error-input .el-input__inner {
  border-color: red;
}
.el-color-picker:not(:hover) > .el-color-picker__trigger {
  border: none;
}
.text-param-field input {
  text-align: center;
}
</style>
